import React from 'react';
import { bool, func, node, string, } from 'prop-types';

import s from './Checkbox.css';
import cx from 'classnames';


const checkmark = <svg className={s.checkmark} version="1.1" x="0px" y="0px" viewBox="0 0 26.9 20.4" aria-hidden="true"><path className={s.checkmarkPath} d="M8.3,19.8l-7.5-7.5c-0.8-0.8-0.8-2,0-2.8l0,0c0.8-0.8,2-0.8,2.8,0L9.1,15L23.3,0.8c0.8-0.8,2-0.8,2.8,0l0,0c0.8,0.8,0.8,2,0,2.8L10,19.8C9.5,20.3,8.8,20.3,8.3,19.8z"/></svg>;

const Checkbox = ({ checked, children, className, disabled, id, onChange, ariaLabel, ...props}) => {

  const handleInputChange = event => {
    if (onChange) onChange(event.target.checked);
  };

  return (
    <div className={cx(s.component, className)}>
      <input
        aria-label={ariaLabel || undefined}
        className={s.hiddenInput}
        checked={checked}
        disabled={disabled}
        id={id}
        onChange={handleInputChange}
        type="checkbox"
        {...props}
        />
      {children ? (
        <label htmlFor={id} className={s.labelWrapper}>
          <span className={cx(s.box, {[`${s.checked}`]: checked})} aria-hidden="true">
            {checkmark}
          </span>
          <span className={s.labelText}>{children}</span>
        </label>
      ) : (
        <label htmlFor={id} className={cx(s.box, {[`${s.checked}`]: checked})} aria-hidden="true">
          {checkmark}
        </label>
      )}
    </div>
  );
};

Checkbox.propTypes = {
  ariaLabel: string,
  checked: bool,
  children: node,
  className: string,
  disabled: bool,
  id: string.isRequired,
  onChange: func,
};

export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/Checkbox/Checkbox.js